/** FAQ, Support, and Advertising page copy (Slovak). */
export const pagesMessagesSk = {
  faq: {
    pageTitle: "Často kladené otázky",
    pageSubtitle: "Nájdite odpovede na bežné otázky o WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Odpovede na bežné otázky o WasOK, skenovaní produktov, súkromí a hodnoteniach.",
    items: [
      {
        question: "Ako funguje WasOK?",
        answer:
          "WasOK vám pomáha zapamätať si, ktoré produkty sa vám páčili alebo nepáčili, tým, že skenuje čiarové kódy a ukladá vaše hodnotenia a poznámky. Jednoducho naskenujte čiarový kód produktu, ohodnoťte ho, pridajte poznámky, a nabudúce, keď naskenujete ten istý produkt, okamžite uvidíte svoje predchádzajúce hodnotenie.",
      },
      {
        question: "Sú moje údaje uložené v cloude?",
        answer:
          "Nie! Všetky vaše údaje sú uložené lokálne vo vašom zariadení. Vaše informácie nesynchronizujeme do cloudu, čo znamená, že vaša história nákupov a názory na produkty zostávajú úplne súkromné. To však tiež znamená, že by ste si mali zálohovať zariadenie, ak chcete svoje údaje zachovať.",
      },
      {
        question: "Potrebujem na používanie WasOK internetové pripojenie?",
        answer:
          "Nie, WasOK funguje úplne offline. Keďže všetky vaše údaje sú uložené lokálne vo vašom zariadení, môžete skenovať produkty, pridávať hodnotenia a prezerať si históriu bez akéhokoľvek internetového pripojenia.",
      },
      {
        question: "Môžem WasOK použiť pre akýkoľvek typ produktu?",
        answer:
          "Áno! WasOK funguje s akýmkoľvek produktom, ktorý má čiarový kód. Či už ide o potraviny, kozmetiku, potreby pre domácnosť, elektroniku alebo čokoľvek iné s čiarovým kódom, môžete to naskenovať a uložiť si svoj názor.",
      },
      {
        question: "Ako naskenujem čiarový kód?",
        answer:
          "Jednoducho otvorte aplikáciu WasOK a ťuknite na tlačidlo skenovania. Namierte fotoaparát na čiarový kód produktu a aplikácia ho automaticky rozpozná a naskenuje. Pre najlepšie výsledky sa uistite, že je čiarový kód dobre osvetlený a zaostrený.",
      },
      {
        question: "Môžem k svojim hodnoteniam produktov pridať fotografie?",
        answer:
          "Áno! K akémukoľvek hodnoteniu produktu môžete pripojiť fotografie. Je to obzvlášť užitočné na zapamätanie si detailov balenia, zoznamu zložiek alebo akýchkoľvek iných vizuálnych informácií, ktoré vám pomôžu spomenúť si, prečo sa vám produkt páčil alebo nepáčil.",
      },
      {
        question: "Aké informácie si môžem o produktoch uložiť?",
        answer:
          "Môžete si uložiť hodnotenia (1-5 hviezdičiek), textové poznámky, fotografie, cenu, ktorú ste zaplatili, miesto nákupu a vlastné kategórie. Tieto komplexné informácie vám pomôžu robiť informované rozhodnutia pri nakupovaní.",
      },
      {
        question: "Môžem si vytvárať nákupné zoznamy?",
        answer:
          "Áno! WasOK vám umožňuje vytvárať nákupné zoznamy z produktov, ktoré ste už hodnotili. Vďaka tomu si ľahko zapamätáte, ktoré produkty ste milovali a chcete si ich kúpiť znova.",
      },
      {
        question: "Ako si organizujem svoje produkty?",
        answer:
          "Produkty môžete organizovať pomocou vlastných kategórií. Môžete si napríklad vytvoriť kategórie ako „Desiatové jedlá“, „Káva“, „Starostlivosť o pleť“ alebo „Čistiace prostriedky“. Vďaka tomu si ľahko prehľadáte svoje hodnotenia podľa typu.",
      },
      {
        question: "Je WasOK bezplatný?",
        answer:
          "Áno, WasOK je úplne bezplatný na stiahnutie a používanie. Neexistujú žiadne nákupy v aplikácii, predplatné ani skryté poplatky. Veríme, že každý by mal mať prístup k súkromnému spôsobu, ako si zapamätať svoje preferencie ohľadom produktov.",
      },
      {
        question: "Je WasOK prístupný?",
        answer:
          "WasOK je navrhnutý tak, aby ho mohlo používať čo najviac ľudí. Aplikácia obsahuje funkcie prístupnosti, ako je podpora čítačky obrazovky, škálovateľný text a voliteľný režim vysokého kontrastu.",
      },
      {
        question: "Čo sa stane, ak aplikáciu odinštalujem?",
        answer:
          "Keďže všetky údaje sú uložené lokálne vo vašom zariadení, odinštalovaním aplikácie sa vymažú všetky vaše hodnotenia produktov, poznámky a nákupné zoznamy. Pred odinštalovaním si nezabudnite exportovať údaje, ak si chcete ponechať zálohu.",
      },
      {
        question: "Môžem exportovať svoje údaje?",
        answer:
          "Áno, WasOK vám umožňuje exportovať vaše údaje na účely zálohovania. Všetky svoje hodnotenia môžete exportovať do súboru, ktorý si môžete uložiť do svojho zariadenia alebo do cloudového úložiska podľa vlastného výberu.",
      },
      {
        question: "Sleduje WasOK moju polohu?",
        answer:
          "Nie, WasOK nesleduje vašu polohu. Aj keď môžete ručne zadať názov obchodu, kde ste produkt kúpili, aplikácia nepoužíva GPS ani lokalizačné služby.",
      },
      {
        question: "Môžem WasOK používať na viacerých zariadeniach?",
        answer:
          "V súčasnosti sa WasOK medzi zariadeniami nesynchronizuje, keďže všetky údaje sú uložené lokálne. Každé zariadenie bude mať vlastnú samostatnú databázu produktov a hodnotení.",
      },
      {
        question: "Čo ak sa čiarový kód nenaskenuje?",
        answer:
          "Ak sa čiarový kód nenaskenuje, uistite sa, že je dobre osvetlený a zaostrený. Môžete tiež skúsiť vyčistiť objektív fotoaparátu. Ak je čiarový kód poškodený alebo nezreteľný, môžete jeho číslo zadať ručne.",
      },
    ],
    cta: {
      heading: "Stále máte otázky?",
      body: "Obráťte sa na náš tím podpory — radi vám pomôžeme.",
      button: "Kontaktovať podporu",
    },
  },
  support: {
    pageTitle: "Podpora",
    seoTitle: "Podpora — WasOK",
    seoDescription:
      "Získajte pomoc s WasOK: kontaktujte podporu, nahláste chyby a podeľte sa o spätnú väzbu.",
    getHelp: {
      title: "Získať pomoc",
      body: "Sme tu, aby sme vám pomohli vyťažiť z WasOK maximum. Ak máte problémy alebo otázky, máme k dispozícii niekoľko zdrojov, ktoré vám pomôžu.",
    },
    faq: {
      title: "Často kladené otázky",
      body: "Skôr než nás kontaktujete, pozrite si našu sekciu FAQ, kde odpovedáme na najčastejšie otázky o WasOK. Nájdete tam podrobné informácie o tom, ako aplikácia funguje, o súkromí, ukladaní údajov a ďalšom.",
    },
    contact: {
      title: "Kontaktovať podporu",
      body: "Ak nemôžete nájsť odpoveď, ktorú hľadáte, náš tím podpory je pripravený pomôcť. Môžete nás kontaktovať na:",
      emailLabel: "E-mail:",
      responseTime: "Zvyčajne odpovedáme do 24-48 hodín",
    },
    bugs: {
      title: "Nahlasovanie chýb",
      body: "Našli ste chybu? Vážime si vašu pomoc pri zlepšovaní WasOK. Pri nahlasovaní chyby, prosím, uveďte:",
      items: [
        "Podrobný popis problému",
        "Kroky na zopakovanie problému",
        "Model vášho zariadenia a verziu Androidu",
        "Snímky obrazovky alebo videozáznamy, ak je to možné",
      ],
      sendPrefix: "Hlásenia o chybách posielajte na:",
    },
    featureRequests: {
      title: "Návrhy na nové funkcie",
      bodyBefore: "Máte nápad na novú funkciu? Radi si ho vypočujeme! Svoje návrhy pošlite na",
      bodyAfter:
        ". Aj keď nedokážeme implementovať každú požiadavku, pri plánovaní budúcich aktualizácií starostlivo zvažujeme všetku spätnú väzbu.",
    },
    knownIssues: {
      title: "Známe problémy",
      body: "V súčasnosti si uvedomujeme nasledujúce problémy a pracujeme na ich riešení:",
      items: [
        "Niektoré čiarové kódy sa nemusia naskenovať pri slabom osvetlení — skúste použiť baterku",
        "Veľmi dlhé poznámky k produktu sa môžu na starších zariadeniach ukladať chvíľu dlhšie",
        "Miniatúry obrázkov sa môžu na displejoch s vysokým rozlíšením javiť rozpixelované",
      ],
    },
    appUpdates: {
      title: "Aktualizácie aplikácie",
      body: "Pravidelne vydávame aktualizácie s novými funkciami, vylepšeniami a opravami chýb. Nezabudnite si udržiavať WasOK aktualizovaný cez Google Play Store, aby ste mali najnovšie vylepšenia.",
    },
    community: {
      title: "Komunita",
      body: "Pridajte sa k našej komunite používateľov, ktorí robia s WasOK inteligentnejšie nákupné rozhodnutia. Zdieľajte tipy, pýtajte sa a spojte sa s ostatnými používateľmi na našich sociálnych kanáloch.",
    },
    emergency: {
      title: "Núdzová podpora",
      body: 'Ak máte kritický problém, ktorý vám bráni používať aplikáciu, prosím, označte svoj e-mail slovom „URGENT“ v predmete a my vašu požiadavku uprednostníme.',
    },
    cta: {
      heading: "Stále potrebujete pomoc?",
      body: "Náš tím podpory je tu pre vás. Neváhajte nás kontaktovať s akýmikoľvek otázkami alebo obavami.",
      button: "Napísať podpore",
    },
  },
  advertising: {
    pageTitle: "Reklama a monetizácia",
    seoTitle: "Reklama — WasOK",
    seoDescription: "Ako WasOK pristupuje k reklame a monetizácii.",
    approach: {
      title: "Náš prístup",
      body: "Vo WasOK veríme, že vaše nákupné návyky a názory na produkty sú súkromné a osobné. Tento základný princíp odráža aj náš obchodný model.",
    },
    noAds: {
      title: "Žiadne reklamy",
      body: "WasOK nezobrazuje žiadne reklamy. Nikdy vám nebudeme zobrazovať reklamy na základe produktov, ktoré skenujete, hodnotení, ktoré udeľujete, ani akýchkoľvek iných údajov, ktoré vytvárate v aplikácii. Vaša skúsenosť s WasOK je úplne bez reklám.",
    },
    noDataSelling: {
      title: "Žiadny predaj údajov",
      body: "Vaše údaje nepredávame, neprenajímame ani nezdieľame s inzerentmi, sprostredkovateľmi údajov ani žiadnymi tretími stranami. Keďže všetky vaše údaje sú uložené lokálne vo vašom zariadení, ani my k nim nemáme prístup. Vaše hodnotenia produktov, nákupné zoznamy a poznámky patria iba vám.",
    },
    noTracking: {
      title: "Žiadne sledovanie",
      body: "WasOK nepoužíva sledovacie pixely, analytické služby ani žiadnu inú technológiu, ktorá by monitorovala vaše správanie alebo zdieľala informácie s tretími stranami. Nesledujeme, ktoré produkty skenujete, v ktorých obchodoch nakupujete ani ako aplikáciu používate.",
    },
    sustainability: {
      title: "Ako zostávame udržateľní",
      body: "Možno vás zaujíma, ako udržiavame WasOK bezplatný bez reklám alebo predaja údajov. Náš prístup je jednoduchý:",
      items: [
        {
          label: "Bezplatné a otvorené:",
          text: "WasOK je bezplatný pre každého, bez prémiových úrovní alebo platených funkcií",
        },
        {
          label: "Efektívna prevádzka:",
          text: "Naše náklady udržiavame nízke tým, že budujeme efektívny softvér zameraný na súkromie",
        },
        {
          label: "Dobrovoľné dary:",
          text: "Používatelia, ktorí majú WasOK radi, nás môžu podporiť dobrovoľnými darmi",
        },
        {
          label: "Otvorený zdroj:",
          text: "Organizáciám môžeme ponúkať poradenské alebo vývojárske služby na mieru",
        },
      ],
    },
    noAffiliate: {
      title: "Žiadne affiliate odkazy",
      body: "WasOK nepoužíva affiliate odkazy ani nezískava provízie od predajcov. Keď naskenujete produkt, nikam vás nepresmerujeme na jeho kúpu. Aplikácia slúži výhradne na vaše osobné vedenie záznamov a rozhodovanie.",
    },
    noPromotions: {
      title: "Žiadna propagácia produktov",
      body: "Neprijímame platby od značiek ani výrobcov za propagáciu ich produktov. WasOK vám nikdy nebude navrhovať produkty, zvýrazňovať konkrétne značky ani žiadnym spôsobom ovplyvňovať vaše hodnotenia. Vaše názory sú len vaše.",
    },
    partnerships: {
      title: "Partnerstvá s tretími stranami",
      body: "WasOK nespolupracuje s marketingovými spoločnosťami, agregátormi údajov ani reklamnými sieťami. Fungujeme nezávisle a nadovšetko uprednostňujeme vaše súkromie.",
    },
    future: {
      title: "Plány do budúcnosti",
      body: "Sme odhodlaní udržať WasOK bez reklám a zameraný na súkromie. Ak by sme niekedy v budúcnosti potrebovali zaviesť udržateľný obchodný model, urobíme nasledujúce:",
      items: [
        "Akékoľvek zmeny oznámime dostatočne vopred",
        "Nikdy neurobíme kompromis v oblasti súkromia alebo bezpečnosti údajov",
        "Vždy ponúkneme spôsob používania aplikácie bez sledovania alebo reklám",
        "Budeme počúvať spätnú väzbu a obavy používateľov",
      ],
    },
    supporting: {
      title: "Podpora WasOK",
      body: "Ak máte WasOK radi a chcete podporiť naše poslanie súkromnej nákupnej pamäte, môžete:",
      items: [
        "Povedať o aplikácii svojim priateľom a rodine",
        "Zanechať pozitívne hodnotenie v Google Play Store",
        "Podeliť sa s nami o svoju spätnú väzbu a návrhy",
        "Zvážiť dobrovoľný dar (ak je k dispozícii)",
      ],
    },
    cta: {
      heading: "Otázky ohľadom našich zásad?",
      body: "Sme transparentní v tom, ako WasOK funguje. Ak máte akékoľvek otázky ohľadom nášho prístupu k súkromiu, monetizácii alebo udržateľnosti, ozvite sa nám.",
      button: "Kontaktujte nás",
    },
  },
};
